module.exports = __webpack_public_path__ + "img/atw.c629e71e.webp";